import { render, staticRenderFns } from "./ProtocolloUtentiViewComponent.vue?vue&type=template&id=920fbbf4"
import script from "./ProtocolloUtentiViewComponent.vue?vue&type=script&lang=js"
export * from "./ProtocolloUtentiViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports